var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 150,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M674.726 136.576L635.099 179.861V143.201H611.166V125.081H597.092V143.201H576.237V202.356L566.432 203.436C566.324 195.937 562.196 189.421 556.097 185.941V177.27H519.831V185.941C513.65 189.467 509.476 196.105 509.476 203.729V208.089C509.476 208.65 509.515 209.177 509.559 209.7L473.331 213.69L543.971 124.248L492.141 94.7856L399.971 213.69V165.715L329.097 162.531L283.706 10L190.234 38.5965L253.251 226.783H635.099V213.69L686.012 145.661L674.726 136.576Z",
    fill: "#dadaee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M560.803 590C570.966 590 579.204 581.762 579.204 571.599C579.204 561.437 570.966 553.199 560.803 553.199C550.641 553.199 542.402 561.437 542.402 571.599C542.402 581.762 550.641 590 560.803 590Z",
    fill: "#4f46e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M354.381 590C364.544 590 372.782 581.762 372.782 571.599C372.782 561.437 364.544 553.199 354.381 553.199C344.219 553.199 335.98 561.437 335.98 571.599C335.98 581.762 344.219 590 354.381 590Z",
    fill: "#4f46e5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M594.444 442.792H279.154C277.294 442.792 275.672 441.529 275.217 439.726L222.704 231.837C222.056 229.272 223.995 226.782 226.64 226.782H692.407C695.384 226.782 697.349 229.88 696.08 232.573L598.117 440.463C597.447 441.885 596.016 442.792 594.444 442.792Z",
    fill: "#4f46e5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.773 266.796H560.807",
    stroke: "#78D2EE",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.141 312.124H604.128",
    stroke: "#78D2EE",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M256.504 357.452H517.005",
    stroke: "#78D2EE",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M266.875 402.78H426.691",
    stroke: "#78D2EE",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M308.77 442.792V455.232C308.77 480.137 328.959 500.327 353.864 500.327H585.04C599.639 500.327 611.474 512.162 611.474 526.761C611.474 541.361 599.639 553.196 585.04 553.196H308.77",
    stroke: "#78D2EE",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M234.387 278.091L202.377 149.289H140.316",
    stroke: "#78D2EE",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.123 129.073H103",
    stroke: "#78D2EE",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.70968516e9462f89cf0d9a35af92ae1c.svg";
export { ForwardRef as ReactComponent };